export default function search() {
	const modal = document.querySelector('#dialog-search');
	const overlay = document.querySelector('.dialog-overlay');
	const searchToggle = document.querySelectorAll('.js-search-toggle');
	const searchInput = document.querySelector('#dialog-search-input');

	const toggleModal = (isOpen) => {
		modal.classList.toggle('is-open', isOpen);
		document.body.classList.toggle('search-open', isOpen);

		if (isOpen && searchInput) {
			setTimeout(() => searchInput.focus(), 100);
		}

		// If the search dialog is being opened, ensure the mobile menu is closed
		if (isOpen) {
			document.body.classList.remove('menu-open');
		}
	};

	searchToggle.forEach((toggle) => {
		toggle.addEventListener('click', () => {
			const isOpen = !modal.classList.contains('is-open');
			toggleModal(isOpen);
		});
	});

	overlay.addEventListener('click', () => toggleModal(false));

	window.addEventListener('click', (event) => {
		if (event.target === modal) {
			toggleModal(false);
		}
	});
}
